import { Branches, BranchesAction, BranchesState } from './BranchesState';

const setDetails = (branches: Branches) => {
  branches = Object.keys(branches).reduce((prev, curr, index) => {
    index += 1;

    const branch = branches[curr];
    const name = branch.name ?? `Branch #${index}`;

    return {
      ...prev,
      [curr]: { ...branch, name, priority: index },
    };
  }, {});

  return branches;
};

export const BranchesReducer = (state: BranchesState, action: BranchesAction): BranchesState => {
  switch (action.type) {
    case 'INIT_BRANCHES': {
      const branches = setDetails(action.payload.branches as Branches);

      return {
        areBranchesLoadedFromServer: false,
        branches,
      };
    }
    case 'ADD_BRANCHES': {
      let branches = {
        ...state.branches,
        ...(action.payload.branches as Branches),
      };

      branches = setDetails(branches);

      return {
        ...state,
        branches: {
          ...state.branches,
          ...branches,
        },
      };
    }
    case 'REMOVE_BRANCHES': {
      return {
        areBranchesLoadedFromServer: false,
        branches: {},
      };
    }
    case 'UPDATE_BRANCH': {
      const { id, name } = action.payload;

      const branch = state.branches[id];

      branch.name = name;

      return {
        ...state,
        branches: {
          ...state.branches,
          [id]: branch,
        },
      };
    }
    case 'ORGANISE_BRANCHES': {
      const { ids } = action.payload;

      const branches = ids.reduce((prev, id, index) => {
        index += 1;
        return {
          ...prev,
          [id]: { ...state.branches[id], priority: index },
        };
      }, {}) as Branches;

      return {
        ...state,
        branches,
      };
    }
    default:
      return state;
  }
};
